import React, { ReactNode, useContext } from "react";
import styled from "styled-components";
import { PageWrapperFiltersContext } from "common/Home/PageWrapper/PageWrapperFilters.context.ts";
import useMedia from "utils/hooks/useMedia.ts";
import FiltersColumn from "common/Filters/FiltersColumn/FiltersColumn.tsx";
import {
  HEADER_HEIGHT,
  MOBILE_HEADER_HEIGHT,
} from "common/Home/General/constants.tsx";
import { PageWrapperContext } from "common/Home/PageWrapper/PageWrapper.context.tsx";
import { useBottomNavigator, useDisablePageScroll } from "utils/hooks/misc.tsx";
import { DrawerContext } from "common/Drawers/Drawer.context.ts";

interface TwoChartsFlatListLayoutProps {
  flatList: ReactNode;
  distanceFromHeader?: number;
}

const TwoChartsFlatListLayout = ({
  flatList,
  distanceFromHeader,
}: TwoChartsFlatListLayoutProps) => {
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { distanceTop } = useContext(PageWrapperContext);
  const { filters } = useContext(PageWrapperFiltersContext);
  const { isDrawer } = useContext(DrawerContext) || {};
  const showFiltersColumnMeasure = useMedia(
    [`(min-width: 1400px)`],
    [true],
    false
  );
  const showFiltersColumn = !isDrawer && showFiltersColumnMeasure;
  useDisablePageScroll(!isDrawer);

  const padding = 16;
  const marginTop = 8;
  const contentDistanceTop =
    (distanceTop || 0) +
    (distanceFromHeader || 0) +
    (isBottomNavigator ? MOBILE_HEADER_HEIGHT : HEADER_HEIGHT) +
    (distanceFromHeader ? 0 : padding);

  const filtersColumn = filters && showFiltersColumn && (
    <FiltersColumn
      expanded={true}
      filtersSelectors={filters.selectors}
      filtersActions={filters.actions}
      width={FILTERS_WIDTH}
      height={`calc(100vh - ${contentDistanceTop}px - ${padding}px - ${marginTop}px)`}
      selectLoadingStates={filters.loadingStatesSelector}
      hideFilterTypes={filters.hideFilterTypes}
      filterTypeToTitle={filters.filterTypeToTitle}
      isLoading={filters.loading}
      style={{ marginTop }}
    />
  );

  if (isBottomNavigator) {
    return flatList;
  }

  return (
    <Wrapper $showFiltersColumn={showFiltersColumn}>
      <FlatListWrapper
        $showFiltersColumn={showFiltersColumn}
        style={{ height: `calc(100vh - ${contentDistanceTop}px)` }}
      >
        {flatList}
      </FlatListWrapper>
      {filtersColumn}
    </Wrapper>
  );
};

export default TwoChartsFlatListLayout;

const FILTERS_WIDTH = 280;

const Wrapper = styled.div<{ $showFiltersColumn?: boolean }>`
  display: grid;
  grid-template-columns: ${(p) =>
    p.$showFiltersColumn ? `auto ${FILTERS_WIDTH}px` : "auto"};
  height: 100%;

  ${(p) =>
    p.$showFiltersColumn &&
    `
    padding-right: 16px;
  `};
`;
const FlatListWrapper = styled.div<{ $showFiltersColumn?: boolean }>`
  ${(p) =>
    p.$showFiltersColumn &&
    `
     margin-right: 8px;
     ul::-webkit-scrollbar,
     div::-webkit-scrollbar,
     &::-webkit-scrollbar {
     width: 8px !important;
     }
  `};
`;
